/*
 * Collectie Lijst — live-laag (thema 4.4, okt 2026)
 *
 * De Collectie Lijst komt uit thema 5.0 en verwacht daar het Stretch-thema om
 * zich heen. Dit bestand is de koppeling met het huidige thema:
 *
 *  1. Mandje. De vlag window.SentirLijstLive laat de Lijst toevoegen en aantallen
 *     wijzigen via window.SentirCart (assets/cart-drawer.js). Zo opent het mandje,
 *     ververst het zichzelf en gaat Klaviyo "Added to Cart" mee.
 *  2. Wijzigt de klant iets ín het mandje, dan leest de Lijst het mandje opnieuw
 *     (de plus/min-knoppen op de kaarten blijven kloppen).
 *  3. Het formulier van een kaart wordt niet echt verzonden; anders telt Shopify
 *     elke toevoeging twee keer (formulier + verzoek).
 *  4. Meldingen ("toast:show") en het wegschuiven van de kop ("sentir:header")
 *     kent dit thema niet; die vertalen we hier.
 *
 * Dit bestand staat bewust niet 'defer': de vlag moet er zijn voordat de Lijst start.
 */
(function () {
  'use strict';

  window.SentirLijstLive = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* 3. Het echte verzenden tegenhouden, in de capture-fase: voor Shopify's eigen formulierteller. */
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (form && form.matches && form.matches('.scl form[data-act]')) event.preventDefault();
    },
    true
  );

  /* 2. Mandje gewijzigd (drawer opnieuw getekend) -> de Lijst bijpraten. */
  var wachter = 0;
  document.addEventListener('sentir:cart:updated', function () {
    window.clearTimeout(wachter);
    wachter = window.setTimeout(function () {
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (antwoord) {
          return antwoord.json();
        })
        .then(function (cart) {
          if (!cart || !cart.items) return;
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'sentir:cart', cart: cart, sentir: true } })
          );
        })
        .catch(function () {});
    }, 150);
  });

  /* 4a. Meldingen. Alleen fouten en korte bevestigingen; het mandje zelf is de gewone terugkoppeling. */
  var toastEl = null;
  var toastTimer = 0;
  document.addEventListener('toast:show', function (event) {
    var detail = (event && event.detail) || {};
    if (!detail.message) return;
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'scl-live-toast wg-notranslate';
      toastEl.setAttribute('translate', 'no');
      toastEl.setAttribute('data-wg-notranslate', '');
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    /* De Lijst levert de tekst al veilig aan (eigen esc()); het zijn vaste zinnen plus een producttitel. */
    toastEl.innerHTML = detail.message;
    toastEl.classList.toggle('is-fout', detail.tone === 'error');
    toastEl.classList.add('is-zichtbaar');
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(function () {
      toastEl.classList.remove('is-zichtbaar');
    }, 3600);
  });

  /* 4c. Weglot. Bij een verse machinevertaling zet Weglot de termen uit zijn vaste woordenlijst tussen „ ”
     (gemeten 9 okt 2026 op nl.: "doordrenkt met „ kruidig ”-wierook"). De aanhalingstekens halen we hier weg.
     De zin zelf verbeteren kan alleen in Weglot (vertaling aanpassen of de woordenlijstregel herzien). */
  function poetsWeglot() {
    var nl = /^nl\./.test(window.location.hostname);
    var els = document.querySelectorAll('.scl .pcard-scent, .scl .pdetail-bron p');
    Array.prototype.forEach.call(els, function (el) {
      var tekst = el.textContent;
      if (tekst.indexOf('\u201E') === -1) return;
      el.textContent = tekst.replace(/\u201E\s*([^\u201D\u201E]{1,40}?)\s*\u201D/g, function (heel, woord) {
        return nl ? woord.charAt(0).toLowerCase() + woord.slice(1) : woord;
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', poetsWeglot);
  else poetsWeglot();

  /* 4b. De kop van dit thema schuift weg bij omlaag scrollen en komt terug bij omhoog. */
  function volgKop() {
    var kop = document.getElementById('shopify-section-header');
    if (!kop || !('MutationObserver' in window)) return;
    new MutationObserver(function () {
      document.dispatchEvent(new CustomEvent('sentir:header'));
      /* na de schuifanimatie (0,15 s) nog een keer, dan staat de balk zeker goed */
      window.setTimeout(function () {
        document.dispatchEvent(new CustomEvent('sentir:header'));
      }, 180);
    }).observe(kop, { attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', volgKop);
  else volgKop();
})();
